module.exports = __webpack_public_path__ + "static/media/konnexions_logo_2.f100d6ae.png";